const QUANTITY_MAX_FRACTION_DIGITS = 8;

/**
 * A quantity of shares or coins: fractional ones keep up to eight places, whole
 * ones show none. The sign is kept.
 *
 * @example formatQuantity(33.99208384602773) // "33.99208385"
 * @example formatQuantity(10)                // "10"
 * @example formatQuantity(1204)              // "1,204"
 */
export default function formatQuantity(quantity: number): string {
  return quantity.toLocaleString('en-US', { maximumFractionDigits: QUANTITY_MAX_FRACTION_DIGITS });
}
